import React from "react";

// components
import { ButtonStandard, ButtonStandardProps } from "../../../../../atoms/ButtonStandard";
// context
import { usePyForm } from "../../../context";

type ResetButtonProps = Omit<ButtonStandardProps, "onClick"> & {
	/**
	 * Function that runs just before the form is reset
	 * @returns void
	 */
	onReset?: () => void;
};

// This is a reusable component that is used to submit the form

export const ResetButton = (props: ResetButtonProps) => {
	const form = usePyForm();
	return (
		<form.Subscribe selector={(state) => [state.isSubmitting]}>
			{([isSubmitting]) => (
				<ButtonStandard
					{...props}
					type="reset"
					onClick={() => {
						props.onReset?.();
						form.reset();
					}}
					disabled={isSubmitting || props.disabled}
					data-testid={`${form.id}-reset-button`}
				>
					{props.children}
				</ButtonStandard>
			)}
		</form.Subscribe>
	);
};

export default ResetButton;
